import { createSelector } from '@ngrx/store';
import { get } from '../../../shared/utils/func';
import { featureState } from './feature.name';

export const invitesState = createSelector(featureState, get('invites'));

export const inviteProcessing = createSelector(invitesState, get('processing'));
